'use client';

import ReactModal, { setAppElement } from 'react-modal';

if (typeof document !== 'undefined') {
  const root = document.getElementById('__next');

  if (root) {
    setAppElement(root);
  }
}

// eslint-disable-next-line import/no-default-export
export default ReactModal;
